import { DOCUMENT, Inject, inject, Injectable } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { environment } from '../../../../environments/environment'

@Injectable({
	providedIn: 'root',
})
export class SeoService {
	private title = inject(Title)
	private meta = inject(Meta)

	constructor(@Inject(DOCUMENT) private dom: Document) {}

	setCanonicalURL(url?: string): void {
		const canonicalURL = url || this.getCleanURL()
		let link: HTMLLinkElement = this.dom.querySelector("link[rel='canonical']") || this.dom.createElement('link')

		link.setAttribute('rel', 'canonical')
		link.setAttribute('href', canonicalURL)

		if (!link.parentElement) {
			this.dom.head.appendChild(link)
		}
	}

	private getCleanURL(): string {
		const urlObject = new URL(this.dom.location.href)
		return `${urlObject.protocol}//${urlObject.host}${urlObject.pathname}`
	}

	setPageMetaData(title: string, metaDescription: string): void {
		this.title.setTitle(title)

		this.meta.updateTag({
			name: 'description',
			content: metaDescription,
		})

		this.meta.updateTag({
			name: 'twitter:card',
			content: 'summary',
		})

		this.meta.updateTag({
			name: 'twitter:title',
			content: title,
		})

		this.meta.updateTag({
			name: 'twitter:description',
			content: metaDescription,
		})

		this.meta.updateTag({
			name: 'twitter:image',
			content: `${environment.webStorageUrl}/custom-content-assets/RadiusAuto/logo/light.png`,
		})
	}
}
